export default "__VITE_ASSET__C7FbDXN6__"